var wsUrl = '',
  userId,
  tt,
  socket,
  lockReconnect = false,
  //这里还需要区分参数是userID还是deviceID
  timeout = 21000,
  timeoutObj = null,
  serverTimeoutObj = null,
  dealSocketData,
  socketFlag = 1
export function webSocket(user, callback) {
  userId = user
  dealSocketData = callback
  if (typeof WebSocket == 'undefined') {
    // console.log("您的浏览器不支持WebSocket");
  } else {
    // lockReconnect 避免重复连接
    if (window.location.href.indexOf('https') >= 0) {
      //如果是https  webSocket 需要遵守wss协议所以这里判断如果是https socket
      wsUrl = 'wss://' + "websocket.yjkpt.net/pay/websocket"
    } else {
      wsUrl = 'ws://' + "websocket.yjkpt.net/pay/websocket"
    }
    console.log('socket 通讯地址：' + wsUrl)

    //调用webSocket链接
    createWebSocket()
  }
}

//创建链接
function createWebSocket() {
  try {
    socket = new WebSocket(wsUrl)
    init2()
  } catch (e) {
    reconnect(wsUrl)
  }
}
/**
 * 初始化链接
 */
function init2() {
  socket.onclose = function () {
    console.log(getNowTime() + ' Socket已关闭')
    if (socketFlag == 1) {
      reconnect(wsUrl)
    } else {
      return
    }
  }
  socket.onerror = function () {
    // reject(getNowTime() + "发生异常了，连接失败，正在发起新连接");
    console.log(getNowTime() + '发生异常了，连接失败，正在发起新连接')
    reconnect(wsUrl)
  }
  socket.onopen = function () {
    console.log(
      getNowTime() + ' Socket 已打开',
      JSON.stringify({ uid: userId })
    )
    socket.send(JSON.stringify({ uid: userId }))
    //心跳检测重置
    heartCheck.start()
  }
  socket.onmessage = function (event) {
    // console.log(getNowTime() + " 接收到消息:" + event.data);
    if (event.data.indexOf('连接成功') < 0) {
      console.log('接收到推送', event.data)
      var obj = eval('(' + event.data + ')')
      dealSocketData(obj)
    }
    heartCheck.start()
    //拿到任何消息都说明当前连接是正常的
    //实时添加消息
  }
}
//重试连接socket
function reconnect(wsUrl) {
  if (lockReconnect) {
    return
  }
  lockReconnect = true
  //没连接上会一直重连，设置延迟避免请求过多
  tt && clearTimeout(tt)
  tt = setTimeout(function () {
    createWebSocket(wsUrl)
    lockReconnect = false
  }, 8000)
}
//心跳检测
let heartCheck = {
  start: function () {
    console.log(getNowTime() + ' Socket 心跳检测')
    timeoutObj && clearTimeout(timeoutObj)
    serverTimeoutObj && clearTimeout(serverTimeoutObj)
    timeoutObj = setTimeout(function () {
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      if (socket) {
        socket.send(JSON.stringify({ uid: userId }))
        serverTimeoutObj = setTimeout(function () {
          socket.close()
        }, timeout)
      }
    }, timeout)
  },
}

function p(s) {
  /*<![CDATA[*/
  return s < 10 ? '0' + s : s
  /*]]>*/
}
function getNowTime() {
  /*<![CDATA[*/
  var myDate = new Date()
  //获取当前年
  var year = myDate.getFullYear()
  //获取当前月
  var month = myDate.getMonth() + 1
  //获取当前日
  var date = myDate.getDate()
  var h = myDate.getHours() //获取当前小时数(0-23)
  var m = myDate.getMinutes() //获取当前分钟数(0-59)
  var s = myDate.getSeconds()
  return (
    year + '-' + p(month) + '-' + p(date) + ' ' + p(h) + ':' + p(m) + ':' + p(s)
  )
  /*]]>*/
}
export function websocketclose() {
  clearTimeout(timeoutObj)
  clearTimeout(serverTimeoutObj)
  socketFlag = 2
  if (socket) {
    socket.close()
    socket = null
  }
  console.log('离开页面，关闭websocket')
}



// WEBPACK FOOTER //
// ./src/utils/socketconn2.js